<div class="mb-3">
  @if (employeeOptions$ | async) {
    <ng-select
      id="typeahead"
      class="cards-dropdown"
      [(ngModel)]="selectedEmployee"
      [items]="(employeeOptions$ | async) ?? []"
      [searchable]="true"
      [clearable]="false"
      [searchFn]="customSearchFn"
      (ngModelChange)="changeSelection()"
      notFoundText="All your employees have cards issued."
      placeholder="Search for an employee">
      <ng-template
        ng-option-tmp
        let-item="item">
        <div class="row align-items-center flex-nowrap">
          <div class="col-auto pe-1">
            <app-avatar
              [firstName]="item.first_name"
              [lastName]="item.last_name"
              [size]="'md'"></app-avatar>
          </div>
          <div class="col-11">
            <div class="text-truncate">{{ item.first_name }} {{ item.last_name }}</div>
          </div>
        </div>
      </ng-template>

      <ng-template
        ng-label-tmp
        let-item="item">
        <div class="row align-items-center flex-nowrap">
          <div class="col-auto pe-1">
            <app-avatar
              [firstName]="item.first_name"
              [lastName]="item.last_name"
              [size]="'sm'"></app-avatar>
          </div>
          <div class="col-10">
            <div class="text-truncate">{{ item.first_name }} {{ item.last_name }}</div>
          </div>
        </div>
      </ng-template>
    </ng-select>
  } @else {
    <app-loader spacingClass="py-1"></app-loader>
  }
</div>
